export const POPULATE_CHANNELS = 'POPULATE_CHANNELS'
export const POPULATE_CURRENT_USER_CHANNELS = 'POPULATE_CURRENT_USER_CHANNELS'
export const RECEIVE_CHANNEL = 'RECEIVE_CHANNEL'
export const SWITCH_CHANNEL = 'SWITCH_CHANNEL'

export const OPEN_SIDEBAR = 'OPEN_SIDEBAR'
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'

export const OPEN_NOTIFICATIONS = 'OPEN_NOTIFICATIONS'
export const CLOSE_NOTIFICATIONS = 'CLOSE_NOTIFICATIONS'

export const OPEN_SEARCH = 'OPEN_SEARCH'
export const CLOSE_SEARCH = 'CLOSE_SEARCH'

export const OPEN_JOB_CREATION = 'OPEN_JOB_CREATION'
export const CLOSE_JOB_CREATION = 'CLOSE_JOB_CREATION'

export const OPEN_CHANNEL_CREATION = 'OPEN_CHANNEL_CREATION'
export const CLOSE_CHANNEL_CREATION = 'CLOSE_CHANNEL_CREATION'

export const SET_SCREEN_WIDTH = 'SET_SCREEN_WIDTH'

function updateChannel (state, channelList, updatedChannel) {
    const index = state[channelList].findIndex(channel => channel.id === updatedChannel.id)

    if (index === -1) {
        state[channelList].push(updatedChannel)
    } else {
        state[channelList].splice(index, 1, updatedChannel)
    }
}

export default {
    [POPULATE_CHANNELS] (state, channels) {
        state.channels = channels
    },

    [POPULATE_CURRENT_USER_CHANNELS] (state, channels) {
        state.currentUserChannels = channels
    },

    [RECEIVE_CHANNEL] (state, updatedChannel) {
        updateChannel(state, 'channels', updatedChannel)
        updateChannel(state, 'currentUserChannels', updatedChannel)
    },

    [SWITCH_CHANNEL] (state, currentChannelId) {
        state.currentChannelId = currentChannelId
    },

    [OPEN_SIDEBAR] (state) {
        state.isSidebarOpen = true
    },

    [CLOSE_SIDEBAR] (state) {
        state.isSidebarOpen = false
    },

    [OPEN_NOTIFICATIONS] (state) {
        state.isNotificationsOpen = true
    },

    [CLOSE_NOTIFICATIONS] (state) {
        state.isNotificationsOpen = false
    },

    [OPEN_SEARCH] (state) {
        state.isSearchOpen = true
    },

    [CLOSE_SEARCH] (state) {
        state.isSearchOpen = false
    },

    [OPEN_JOB_CREATION] (state) {
        state.isCreatingJob = true
    },

    [CLOSE_JOB_CREATION] (state) {
        state.isCreatingJob = false
    },

    [OPEN_CHANNEL_CREATION] (state) {
        state.isCreatingChannel = true
    },

    [CLOSE_CHANNEL_CREATION] (state) {
        state.isCreatingChannel = false
    },
    [SET_SCREEN_WIDTH] (state, width) {
        state.screenWidth = width
    },

    REMOVE_CHANNEL (state, channelId) {
        state.channels = state.channels.filter(channel => channel.id !== channelId)
        state.currentUserChannels = state.currentUserChannels.filter(channel => channel.id !== channelId)
    }
}
